import {
  IconSocialDzen24,
  IconSocialFacebook24,
  IconSocialGoogle24,
  IconSocialInstagram24,
  IconSocialMax24,
  IconSocialOK24,
  IconSocialTelegram24,
  IconSocialVK24,
  IconSocialVKVideo24,
  IconSocialYoutube24,
} from '@cian/ui-kit-design-tokens/icons';
import type { ComponentType } from 'react';
import type { TRenderedSocialItem, TSocialIcon, TSocialItem } from 'shared/types/socials';

const SOCIAL_ICON_COMPONENTS: Record<TSocialIcon, ComponentType> = {
  dzen: IconSocialDzen24,
  facebook: IconSocialFacebook24,
  google: IconSocialGoogle24,
  instagram: IconSocialInstagram24,
  max: IconSocialMax24,
  ok: IconSocialOK24,
  telegram: IconSocialTelegram24,
  vk: IconSocialVK24,
  vkVideo: IconSocialVKVideo24,
  youtube: IconSocialYoutube24,
};

const isSocialIcon = (icon: string): icon is TSocialIcon => icon in SOCIAL_ICON_COMPONENTS;

export const mapSocialItem = (item: TSocialItem): TRenderedSocialItem | null => {
  if (!isSocialIcon(item.icon)) {
    return null;
  }

  return {
    Icon: SOCIAL_ICON_COMPONENTS[item.icon],
    url: item.url,
  };
};

export const mapSocialItems = (items: TSocialItem[]): TRenderedSocialItem[] => {
  return items.flatMap(item => {
    const mappedItem = mapSocialItem(item);

    return mappedItem ? [mappedItem] : [];
  });
};
